import { getConstant } from '../utils';

export const getRegistrants = getConstant('GET_REGISTRANTS');
export const getRegistrant = getConstant('GET_REGISTRANT');
